export default __webpack_public_path__ + "static/media/tabActive.a5606610.png";